import { msiRequest } from "../../../index";
import { ResultType } from "../../../types";
import qs from "qs";
//接口url枚举
enum StatisticalEnumApi {
  WareToolHous_PAGE = "/WareToolHous/page", //分页查询工量具入库
  WareToolHous_ADD = "/WareToolHous/add", //增加工量具基础表
  WareToolHous_EDIT = "/WareToolHous/edit", //更新
  WareToolHous_DELETE = "/WareToolHous/delete", //删除
  WareToolHous_DETAIL = "/WareToolHous/detail" //详情
}
//工量具入库 --- 列表
export function getWareToolHousPage(data: any = {}) {
  return msiRequest.get<ResultType<any>>({
    url: `${StatisticalEnumApi.WareToolHous_PAGE}?${qs.stringify(data)}`,
    data
  });
}

//工量具入库 -- 添加
export function addWareToolHous(data: any = {}) {
  return msiRequest.post<ResultType<any>>({
    url: StatisticalEnumApi.WareToolHous_ADD,
    data
  });
}

//工量具入库 -- 编辑
export function editWareToolHous(data: any = {}) {
  return msiRequest.post<ResultType<any>>({
    url: StatisticalEnumApi.WareToolHous_EDIT,
    data
  });
}

//工量具入库 -- 删除
export function deleteWareToolHous(data: { orderNo: string }) {
  return msiRequest.post<ResultType<any>>({
    url: StatisticalEnumApi.WareToolHous_DELETE,
    data
  });
}

//工量具入库 -- 详情
export function detailWareToolHous(id: number) {
  return msiRequest.get<ResultType<any>>({
    url: `${StatisticalEnumApi.WareToolHous_DETAIL}?Id=${id}`
  });
}
